<template>
    <div class="form-input-checkbox">
        <div class="input">
            <label class="switch">
                <input type="checkbox" :checked="value" :id="id" @change="handleInput">
                <div class="slider"></div>
            </label>
            <label :for="id">{{ label }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-checkbox",
    model:{
        prop:'value',
        event:'change',
    },
    props:{
        label:String,
        value:Boolean,
        text:String,
    },
    data(){
        return{
            id:'checkbox-'+(new Date().getTime())+"-"+Math.round(Math.random() * 10000),
        }
    },
    methods:{
        handleInput(e){
            this.$emit("change",e.target.checked)
        }
    }
}
</script>
